import React, {useEffect, useState} from "react";
import Swal from "sweetalert2";
import axios from "axios";
import {useHistory} from "react-router-dom";

function CaseManagement() {
    const navigate = useHistory();
    const [PortalList, setPortalList] = useState([]); // List of all portals
    const [SourcePortalCases, setSourcePortalCases] = useState([]); // List of all cases present in selected source portal
    const [TargetPortalCases, setTargetPortalCases] = useState([]); // List of all cases to be transferred in selected target portal
    const [SourcePortalId, setSourcePortalId] = useState(""); // ID of selected source portal
    const [TargetPortalId, setTargetPortalId] = useState(""); // ID of selected target portal
    const [SelectedPortalCases, setSelectedPortalCases] = useState([]); // Temporary list to store selected / checked cases(from source portal)
    const [sourceSearchQuery, setSourceSearchQuery] = useState(""); // Search filter state (for source portal)
    const [targetSearchQuery, setTargetSearchQuery] = useState(""); // Search filter state (for target portal)
    const [casesLimit, setCasesLimit] = useState(""); // Stores the total case limit (set to the selected target portal)
    const [casesRemaining, setCasesRemaining] = useState(""); // Stores the remaining case limit (set to the selected target portal)
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        // Load all portals
        LoadPortals();
    }, [],);

    // Fetch List of all portals
    const LoadPortals = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/GetPortalList`).then((res) => {
            setPortalList(res.data);
        });
    };

    // Handle selecting/deselecting of "Source Portal"
    const onSourcePortalSelected = (event) => {
        setSourceSearchQuery("");
        setTargetSearchQuery("");
        setSelectedPortalCases([]);
        setTargetPortalCases([]);
        setSourcePortalCases([]);
        setSourcePortalId("");

        if (!event.target.value)
            return;

        const selectedItem = PortalList.find((portal) => portal.portalId == event.target.value);

        if (TargetPortalId && TargetPortalId === selectedItem.portalId) {
            Swal.fire({
                title: "Alert!",
                text: "Source and target portal can not be same!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        }
        setSourcePortalId(selectedItem.portalId);
        axios.get(`${process.env.REACT_APP_API_URL}/GetAllNewCasesByPortal?portalId=` + selectedItem.portalId).then((res) => {
            setSourcePortalCases(res.data);
        });
    }

    // Handle selecting/deselecting of "Target Portal"
    const onTargetPortalSelected = (event) => {
        setTargetSearchQuery("");
        setCasesLimit("");
        setCasesRemaining("");
        // setTargetPortalCases([]);
        // setTargetPortalId("");

        if (!event.target.value)
            return;

        const selectedItem = PortalList.find((portal) => portal.portalId == event.target.value);

        if (SourcePortalId && SourcePortalId === selectedItem.portalId) {
            Swal.fire({
                title: "Alert!",
                text: "Source and target portal can not be same!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        }
        setTargetPortalId(selectedItem.portalId);
        const casesRemaining = selectedItem.casesRemaining;
        const casesLimit = selectedItem.casesLimit;
        const totalCasesLimit = selectedItem.totalCasesLimit;
        const limit = totalCasesLimit > 0 ? totalCasesLimit : casesLimit;

        if (limit > 0) {
            setCasesLimit(limit);
            setCasesRemaining(casesRemaining);
        } else {
            setCasesLimit("");
            setCasesRemaining("");
        }

        if (limit > 0 && casesRemaining < 1) {
            Swal.fire({
                title: "Limit!",
                text: "You have reached the maximum number of cases for this portal!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        }
    }

    // Handle selecting/deselecting items
    const toggleSelection = (id) => {
        setSelectedPortalCases((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((item) => item !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };

    // Function to sort items alphabetically
    const sortItems = (list) => {
        return [...list].sort((a, b) => a.caseName.localeCompare(b.caseName));
    };

    // Handle transferring items to the right side
    const transferItems = () => {
        const selectedObjects = SourcePortalCases.filter((item) => SelectedPortalCases.includes(item.caseId));
        setTargetPortalCases(sortItems([...TargetPortalCases, ...selectedObjects]));

        // Remove transferred items from left side
        setSourcePortalCases(sortItems(SourcePortalCases.filter((item) => !SelectedPortalCases.includes(item.caseId))));

        // Clear selection after transfer
        setSelectedPortalCases([]);
    };

    // Remove item from right side and move it back to left
    const removeItem = (id) => {
        const itemToRemove = TargetPortalCases.find((item) => item.caseId === id);
        setSourcePortalCases(sortItems([...SourcePortalCases, itemToRemove])); // Add back to left side
        setTargetPortalCases(sortItems(TargetPortalCases.filter((item) => item.caseId !== id))); // Remove from right side
    };

    // Filter items based on search query
    const filteredItems = sortItems(SourcePortalCases).filter((item) =>
        item.caseName.toLowerCase().includes(sourceSearchQuery.toLowerCase())
    );

    const filteredItemsRight = sortItems(TargetPortalCases).filter((item) =>
        item.caseName.toLowerCase().includes(targetSearchQuery.toLowerCase())
    );

    // Select all visible items
    const selectAll = () => {
        const visibleItemIds = filteredItems.map((item) => item.caseId);
        setSelectedPortalCases(
            SelectedPortalCases.length === visibleItemIds.length ? [] : visibleItemIds
        );
    };

    // Handle submit
    const updatePortalCases = () => {
        // Check if target portal is selected
        if (!TargetPortalId) {
            Swal.fire({
                title: "Alert!",
                text: "Target Portal is not selected!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
            return;
        }

        // Check if target portal contains any cases
        if (!TargetPortalCases || TargetPortalCases.length <= 0) {
            Swal.fire({
                title: "Alert!",
                text: "Target portal doesn't contain any case.",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
            return;
        }

        // Check if source and target portal are same
        if (SourcePortalId === TargetPortalId) {
            Swal.fire({
                title: "Alert!",
                text: "Source and target portal can not be same!",
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
            return;
        }

        // build data to submit
        const dataValue = {
            sourcePId: SourcePortalId,
            targetPId: TargetPortalId,
            casesList: TargetPortalCases,
        };

        const authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/UpdatePortalCases`,
            data: dataValue,
            headers: {"Content-Type": "application/json"},
        };

        setIsSubmitting(true);

        axios(authOptions).then((res) => {
            setIsSubmitting(false);

            if (res.data.ExpResult) {
                // Data not saved in database
                Swal.fire({
                    title: "Failed",
                    text: res.data.ExpResult,
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else if (res.data.SuccessResult) {
                // Data successfully saved in database
                Swal.fire({
                    title: "Success",
                    text: res.data.SuccessResult,
                    icon: "success",
                    confirmButtonText: "Ok",
                }).then(function () {
                    window.location.reload();
                });
            } else {
                // unexpected error occurred
                Swal.fire({
                    title: "Error",
                    text: "An error occured!",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        }).catch((err) => {
            console.log(err);
            Swal.fire({
                title: "Error!",
                text: "An error occurred while adding cases." + err.message,
                icon: "warning",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
            });
        });
    }

    // Click Listener on Back  Button
    const BackFunc = () => {
        navigate.push("/index");
    };

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content" style={{minHeight: "10vh"}}>
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title my-0">Case Management</div>
                            </div>
                        </div>
                        <div className="page-title-breadcrumb">
                            <div className=" pull-right">
                                <button
                                    type="submit"
                                    className="btn d-inline-block"
                                    style={{
                                        backgroundColor: "#1e2b38",
                                        color: "#FFF",
                                        border: "1px solid #1e2b38"
                                    }}
                                    onClick={BackFunc}
                                >
                                    {" "}
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    {/***** Card Starts /*****/}
                                    <div className="card">
                                        {/***** Card Header Starts /*****/}
                                        {/*<div className="card-head">*/}
                                        {/*     <header>Transfer Case(s)</header>*/}
                                        {/*</div>*/}
                                        {/***** Card Header ENDS /*****/}

                                        {/***** Card Body Starts /*****/}
                                        <div className="card-body ">
                                            <div className="container-fluid p-0">
                                                <div className="row h-100">
                                                    {/*Source Portal Section*/}
                                                    <div className="col-md-5 d-flex p-0 card"
                                                         style={{boxShadow: "none"}}>
                                                        <div className="card-head">
                                                            <header>
                                                                <select
                                                                    className="form-control select2"
                                                                    onChange={onSourcePortalSelected}
                                                                >
                                                                    <option value="">-- Source Portal --</option>
                                                                    {PortalList.map((result) => {
                                                                        return (
                                                                            <option value={result.portalId}
                                                                                    key={result.portalId}>
                                                                                {result.portalName}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>

                                                            </header>
                                                        </div>
                                                        <div className="card-body"
                                                             style={{minHeight: "60vh", overflowY: "auto"}}>

                                                            {/* Search Input */}
                                                            {SourcePortalCases.length > 0 &&
                                                                <input
                                                                    type="text"
                                                                    className="form-control mb-3"
                                                                    placeholder="Search cases..."
                                                                    value={sourceSearchQuery}
                                                                    onChange={(e) => setSourceSearchQuery(e.target.value)}
                                                                />
                                                            }
                                                            {/* Filtered List */}
                                                            {SourcePortalCases.length > 0 &&
                                                                <ul className="list-group w-100">
                                                                    {filteredItems.length > 0 ? (
                                                                        filteredItems.map((item) => (
                                                                            <li
                                                                                key={item.caseId}
                                                                                className="list-group-item d-flex align-items-center justify-content-between"
                                                                                onClick={() => toggleSelection(item.caseId)}
                                                                                style={{cursor: "pointer"}}
                                                                            >
                                                                                <div
                                                                                    className="d-flex align-items-center">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input me-2"
                                                                                        checked={SelectedPortalCases.includes(item.caseId)}
                                                                                        onClick={(e) => e.stopPropagation()} // Prevents double toggle
                                                                                        onChange={() => toggleSelection(item.caseId)}
                                                                                    />
                                                                                    <span>{item.caseName}</span>
                                                                                </div>
                                                                                <span>{item.caseId}</span>
                                                                            </li>
                                                                        ))
                                                                    ) : (
                                                                        <li className="list-group-item text-dark">No
                                                                            items found</li>
                                                                    )}
                                                                </ul>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/*Center Buttons*/}
                                                    <div
                                                        className="col-md-1 justify-content-center d-flex">
                                                        <div style={{textAlign: "center", marginTop: "230px"}}>
                                                            {/* Select All Button */}
                                                            <button className="btn btn-light my-2" onClick={selectAll}
                                                                    disabled={filteredItems.length === 0}>
                                                                {SelectedPortalCases.length === filteredItems.length ? "Deselect All" : "Select All"}
                                                            </button>
                                                            <button className="btn my-2"
                                                                    disabled={SelectedPortalCases.length === 0}
                                                                    style={{
                                                                        backgroundColor: "#1e2b38",
                                                                        color: "#FFF",
                                                                        border: "1px solid #1e2b38",
                                                                        paddingLeft: "30px",
                                                                        paddingRight: "30px",
                                                                        textAlign: "center",
                                                                        textDecoration: "none",
                                                                        fontSize: "15px"
                                                                    }}
                                                                    onClick={transferItems}>&gt;&gt;
                                                            </button>

                                                            {!isSubmitting &&
                                                                <button className="btn my-2"
                                                                        style={{
                                                                            backgroundColor: "#1e2b38",
                                                                            color: "#FFF",
                                                                            border: "1px solid #1e2b38"
                                                                        }}
                                                                        onClick={updatePortalCases}>Submit</button>
                                                            }

                                                            {isSubmitting &&
                                                                <button className="btn my-2"
                                                                        style={{
                                                                            backgroundColor: "#1e2b38",
                                                                            color: "#FFF",
                                                                            border: "1px solid #1e2b38"
                                                                        }}
                                                                        onClick={updatePortalCases} disabled>

                                                        <span className="spinner-grow spinner-grow-sm me-2"
                                                              aria-hidden="true"></span>
                                                                    <span role="status">Submitting...</span>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/*Target Portal Section*/}
                                                    <div className="col-md-6 d-flex p-0 card"
                                                         style={{boxShadow: "none"}}>
                                                        <div className="card-head">
                                                            <header>
                                                                <select
                                                                    style={{marginBottom: "10px"}}
                                                                    className="form-control select2"
                                                                    onChange={onTargetPortalSelected}
                                                                >
                                                                    <option value="">-- Target Portal --</option>
                                                                    {PortalList.map((result) => {
                                                                        return (
                                                                            <option value={result.portalId}
                                                                                    key={result.portalId}>
                                                                                {result.portalName}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                                <span id="txtCasesRemaining"
                                                                      style={{
                                                                          color: "#1e2e38",
                                                                          fontWeight: "600",
                                                                          paddingLeft: "5px"
                                                                      }}>
                                                                {casesLimit && `Cases Remaining : ${casesRemaining}/${casesLimit}`}
                                                            </span>
                                                            </header>
                                                        </div>
                                                        <div className="card-body">
                                                            {/* Show search only when there are transferred items */}
                                                            {TargetPortalCases.length > 0 && (
                                                                <input
                                                                    type="text"
                                                                    className="form-control mb-3"
                                                                    placeholder="Search cases..."
                                                                    value={targetSearchQuery}
                                                                    onChange={(e) => setTargetSearchQuery(e.target.value)}
                                                                />
                                                            )}

                                                            {TargetPortalCases.length > 0 ? (
                                                                <ul className="list-group w-100">
                                                                    {filteredItemsRight.length > 0 ? (
                                                                        filteredItemsRight.map((item) => (
                                                                            <li key={item.caseId}
                                                                                className="list-group-item d-flex justify-content-between align-items-center text-dark">
                                                                                <div
                                                                                    className="d-flex align-items-center">
                                                                                    <span>{item.caseId}</span>
                                                                                </div>
                                                                                <span>{item.caseName}</span>
                                                                                <button
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => removeItem(item.caseId)}>✖
                                                                                </button>
                                                                            </li>
                                                                        ))
                                                                    ) : (
                                                                        <li className="list-group-item text-dark">No
                                                                            items found</li>
                                                                    )}
                                                                </ul>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/***** Card Body ENDS /*****/}
                                    </div>
                                    {/***** Card ENDS /*****/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CaseManagement;
